<template>
  <div
    id="newsletter-form"
  >
    <email-form
      emailType="newsletter"
      :emailId="newsletterId"
    />
  </div>
</template>

<script>
import EmailForm from '@/components/EmailForm'

export default {
  data () {
    return {
    }
  },

  props: {
    newsletterId: {
      type: [ Number, String ],
      default: undefined
    }
  },

  components: {
    'email-form': EmailForm
  },

  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterForm.vue